import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import ReconnectingWebSocket from "reconnecting-websocket";
import { V_URL_API_WS } from "../utils/config";
import useTokenValidation from "../hooks/useTokenValidation";

// Creamos el contexto
const WebSocketContext = createContext(null);

// Proveedor del WebSocket
export const WebSocketProvider = ({children }) => {
  const [mensajeWs, setMensajeWs] = useState(null);
  const [vIsActivo, setVIsActivo] = useState(false)
  const { tokenEntity, resetearToken, errores, notificacionRef } =
    useTokenValidation();
  const ws = useRef(null);

  useEffect(() => {
    let pingTimeout;

    if (tokenEntity.isValido) {
      ws.current = new ReconnectingWebSocket(`wss://${V_URL_API_WS}/ws/${tokenEntity.token}`);

      ws.current.onopen = () => {
        setVIsActivo(true);
        console.log("✅ Conectado al servidor WebSocket:", V_URL_API_WS);
      };

      ws.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "ping") {
            console.log("Ping recibido del servidor.");
            clearTimeout(pingTimeout);
            pingTimeout = setTimeout(() => {
              console.log("No se recibió ping, reconectando...");
              ws.current.close();
            }, 35000); // Tiempo de espera para el siguiente ping
          } else {
            console.log("📩 Mensaje recibido:", data);
            setMensajeWs(data);
          }
        } catch (error) {
          console.error("⚠️ Error al parsear el mensajeWs:", error);
        }
      };

      ws.current.onerror = (error) => {
        console.error("❌ Error en WebSocket:", error);
      };

      ws.current.onclose = () => {
        setVIsActivo(false);
        console.log("🔴 Conexión WebSocket cerrada");
        clearTimeout(pingTimeout);
      };

      return () => {
        if (ws.current) {
          ws.current.close();
        }
        clearTimeout(pingTimeout);
      };
    }
  }, [tokenEntity]);

  // Función para enviar mensajes
  const enviarMensaje = (mensajeWs) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(mensajeWs));
    } else {
      console.warn("⚠️ No se puede enviar el mensajeWs, WebSocket no está conectado.");
    }
  };

  return (
    <WebSocketContext.Provider value={{ mensajeWs, enviarMensaje,vIsActivo }}>
      {children}
    </WebSocketContext.Provider>
  );
};

// Hook para usar el WebSocket en cualquier componente

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  return context || { 
    mensajeWs: null, 
    enviarMensaje: () => {
      console.warn("⚠️ Intentaste enviar un mensaje sin WebSocket activo.");
    },
    vIsActivo: false
  };
};

/** ORIGINAL 
export const useWebSocket = () => {
  return useContext(WebSocketContext);
};

*/